import { v4 } from 'uuid'

import {
  callPresignedUrl,
  completeMultipartUpload,
  createPresignedUrl,
  initiateMultipartUpload,
} from 'api/storage'

export const uploadBrandingLogo = async (file) => {
  const uploadTypeConfig = { upload_type: 'media' }

  const { content: initialUploadData, error: initiateError } = await initiateMultipartUpload(
    { object_name: `branding-${v4()}-${file.name}`, content_type: file.type },
    uploadTypeConfig,
  )
  if (initiateError) return { success: false, error: initiateError }

  const { upload_id: uploadId, object_key: objectKey } = initialUploadData

  const { content: presignedUrls, error: presignError } = await createPresignedUrl(
    {
      upload_id: uploadId,
      object_key: objectKey,
      start_part_number: 1,
      total_parts: 1,
      total_uploaded_parts: 0,
    },
    uploadTypeConfig,
  )
  if (presignError) return { success: false, error: presignError }

  const { content: partResult, error: putError } = await callPresignedUrl(presignedUrls[0], file)
  if (putError) return { success: false, error: putError }

  const { content: completed, error: completeError } = await completeMultipartUpload(
    {
      upload_id: uploadId,
      object_key: objectKey,
      parts: [{ part_number: 1, etag: partResult.etag }],
    },
    uploadTypeConfig,
  )
  if (completeError) return { success: false, error: completeError }

  return { success: true, url: completed.location }
}
